'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentCbAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 2.5,
          fill: "url(#paint0_linear_647_1953)",
          stroke: "#F1F1F1"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M31.6087 28.1408H42.9822C42.8808 25.6795 42.308 23.1418 40.5707 21.5118C38.5012 19.5702 34.8764 18.85 31.6375 18.85C28.2663 18.85 24.5381 19.6399 22.4577 21.7232C20.6637 23.5177 20.2759 26.4051 20.2759 28.9994C20.2759 31.7168 21.0346 34.8777 22.9808 36.6984C25.0502 38.6357 28.4035 39.15 31.6375 39.15C34.779 39.15 38.182 38.5692 40.2395 36.73C42.2911 34.893 43.0001 31.7986 43.0001 28.9994V28.9864H31.6087V28.1408ZM43.7456 28.9868V38.6961H59.5673V38.683C61.8824 38.5566 63.7241 36.4668 63.7241 33.9008C63.7241 31.3338 61.8824 29.1099 59.5673 28.9824V28.9868H43.7456ZM59.3871 19.2565C61.6435 19.2565 63.4346 21.2167 63.4346 23.69C63.4346 26.0315 61.7897 27.9437 59.6974 28.1409H43.7454V19.2423H58.8879C58.981 19.2309 59.0896 19.2389 59.1958 19.2468C59.262 19.2517 59.3272 19.2565 59.3871 19.2565Z",
          fill: "#FEFEFE"
        }
      ),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
        "linearGradient",
        {
          id: "paint0_linear_647_1953",
          x1: 22.7842,
          y1: -7.34471,
          x2: 2.32646,
          y2: 55.382,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { stopColor: "#222E72" }),
            /* @__PURE__ */ jsx("stop", { offset: 0.591647, stopColor: "#40CBFF" }),
            /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#3CB792" })
          ]
        }
      ) })
    ]
  }
);
const VpPaymentCbAsset = forwardRef(PaymentCbAsset);

export { VpPaymentCbAsset as default };
